import React, { useState, useEffect, Fragment, useCallback } from 'react'
import { Button, Card, Col, Form, Table } from 'react-bootstrap'
import Colors from '../../constants/Colors'
import CONSTANTS, { BANK_LENGTH, bankCode, banks } from '../../constants/constants'
import config from '../../config'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import styled from 'styled-components'

const BANK_OPTIONS = Object.keys(CONSTANTS.banks)
  .filter((key) => key === 'KBANK' || key === 'KTB' || key === 'SCB')
  .reduce((obj, key) => {
    obj[key] = CONSTANTS.banks[key]
    return obj
  }, {})

const BookBankCollection = () => {
  const INITIAL_BANK_DETAIL = {
    accountNo: '',
    bankCode: Object.values(CONSTANTS.bankCode)[0],
    bankName: `${Object.keys(BANK_OPTIONS)[0]}`,
    accountName: '',
    enabled: false,
  }
  const [bankList, setBankList] = useState([])
  const [bankDetail, setBankDetail] = useState(INITIAL_BANK_DETAIL)
  const [configList, setConfigList] = useState([])

  const onBankNameChange = (e) => {
    setBankDetail({ ...bankDetail, bankCode: bankCode[e.target.value], bankName: e.target.value })
  }

  const customizeModal = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    })
  }

  const fetchBankAccount = useCallback(async (page = 1, limit = 10) => {
    try {
      const response = await fetch(
        `${config.apiAdminGateway}/api/v1/admin/configs/bank-transfers?page=${page}&limit=${limit}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      ).then((res) => res.json())

      if (response.status.code !== 0) throw new Error('Error fetching bank account')

      setBankList(response.data)
    } catch {
      customizeModal('เกิดข้อผิดพลาดระหว่างดึงข้อมูลบัญชีธนาคาร', 'กรุณาลองใหม่อีกครั้ง', 'error')
    }
  }, [])

  const addBankAccount = async () => {
    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/configs/bank-transfers`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
        body: JSON.stringify(bankDetail),
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error('Error adding bank account')

      customizeModal('บันทึกสำเร็จ', '', 'success')
      setBankDetail(INITIAL_BANK_DETAIL)
    } catch {
      customizeModal('เกิดข้อผิดพลาดระหว่างดึงข้อมูลบัญชีธนาคาร', 'กรุณาลองใหม่อีกครั้ง', 'error')
    } finally {
      fetchBankAccount()
    }
  }

  const deleteBankAccount = async (id) => {
    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/configs/bank-transfers/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error('Error deleting bank account')

      customizeModal('ลบสำเร็จ', '', 'success')
    } catch {
      Swal.fire({
        title: 'เกิดข้อผิดพลาดระหว่างลบข้อมูลบัญชีธนาคาร',
        text: 'กรุณาลองใหม่อีกครั้ง',
        icon: 'error',
      })
    } finally {
      fetchBankAccount()
    }
  }

  const handleClickDelete = (id) => {
    Swal.fire({
      title: 'ยืนยันการลบบัญชีธนาคาร',
      text: 'กรุณาทำการตรวจสอบก่อนลบ',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'ลบ',
      cancelButtonText: 'ปิด',
    }).then((result) => {
      if (result.isConfirmed) {
        deleteBankAccount(id)
      }
    })
  }

  const fetchConfig = useCallback(async () => {
    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/configs`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error('Error fetching config')

      setConfigList(response.data)
    } catch {
      customizeModal('เกิดข้อผิดพลาดระหว่างดึงข้อมูล', 'กรุณาลองใหม่อีกครั้ง', 'error')
    }
  }, [])

  const onSubmit = () => {
    switch (true) {
      case !BANK_LENGTH[bankDetail.bankName] ||
        bankDetail.accountNo.length < BANK_LENGTH[bankDetail.bankName].accountMinLength ||
        bankDetail.accountNo.length > BANK_LENGTH[bankDetail.bankName].accountMaxLength:
        customizeModal('เลขบัญชีไม่ครบถ้วน', 'กรุณาลองใหม่อีกครั้ง', 'error')
        break
      case bankDetail.bankName === '':
        customizeModal('กรุณาเลือกธนาคาร', 'กรุณาลองใหม่อีกครั้ง', 'error')
        break
      case bankDetail.accountName === '':
        customizeModal('เกิดข้อผิดพลาดระหว่างดึงข้อมูลบัญชีธนาคาร', 'กรุณาลองใหม่อีกครั้ง', 'error')
        break
      case bankList.length >= 2:
        customizeModal('ขณะนี้ไม่สามารถเพิ่มบัญชีธนาคาร', 'บัญชีธนาคารสามารถเพิ่มได้สูงสุด 2 บัญชี', 'error')
        break
      default:
        Swal.fire({
          title: 'ยืนยันการบันทึก',
          text: 'กรุณาทำการตรวจสอบข้อมูลให้ครบถ้วนก่อนบันทึก',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'บันทึก',
          cancelButtonText: 'ปิด',
        }).then((result) => {
          if (result.isConfirmed) {
            addBankAccount()
          }
        })
    }
  }

  const enableBankAccount = async (id) => {
    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/configs/bank-transfers/${id}/enable`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error('Error enable bank account')

      Swal.fire({
        title: 'เปลี่ยนสถานะสําเร็จ',
        icon: 'success',
      })
    } catch {
      Swal.fire({
        title: 'เกิดข้อผิดพลาดระหว่างเปลี่ยนสถานะบัญชีธนาคาร',
        text: 'กรุณาลองใหม่อีกครั้ง',
        icon: 'error',
      })
    } finally {
      fetchBankAccount()
    }
  }

  useEffect(() => {
    fetchConfig()
  }, [fetchConfig])

  useEffect(() => {
    fetchBankAccount()
  }, [fetchBankAccount])

  return (
    <Card>
      <Card.Header>
        <Card.Title>BookBankCollection</Card.Title>
      </Card.Header>
      <Card.Body>
        <HeaderContainer>
          <TitleText>จัดการบัญชีธนาคาร</TitleText>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>ธนาคาร</th>
                <th>ชื่อบัญชี</th>
                <th>เลขบัญชี</th>
                <th>จัดการ</th>
              </tr>
            </thead>
            <tbody>
              {bankList.map((bank, i) => (
                <tr key={i}>
                  <td>{banks[bank.bankName]}</td>
                  <td>{bank.accountName}</td>
                  <td>{bank.accountNo}</td>
                  <td>
                    <ButtonCotainer>
                      <Button
                        variant={bank.enabled ? 'info light' : 'primary light'}
                        onClick={() => enableBankAccount(bank.id)}
                        disabled={bank.enabled || !configList.isEnableSlip}
                      >
                        {bank.enabled ? 'Active' : 'Enable'}
                      </Button>
                      {!bank.enabled && (
                        <Button variant="danger light" onClick={() => handleClickDelete(bank.id)}>
                          Delete
                        </Button>
                      )}
                    </ButtonCotainer>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </HeaderContainer>
        <Form.Group>
          <BodyContainer>
            <TitleText>เพิ่มบัญชีธนาคาร</TitleText>
            <Col>
              <Form.Control
                as="select"
                className="form-control"
                value={bankDetail.bankName}
                onChange={onBankNameChange}
              >
                {Object.keys(BANK_OPTIONS).map((bank) => (
                  <option value={bank} key={bank}>
                    {BANK_OPTIONS[bank]}
                  </option>
                ))}
              </Form.Control>
            </Col>
            <Col>ชื่อบัญชี</Col>
            <Col sm={12} md={6} lg={4}>
              <input
                className="form-control my-2"
                style={{ color: Colors.DARK_GREY }}
                type="text"
                placeholder="กรุณากรอกชื่อบัญชีธนาคาร"
                value={bankDetail.accountName}
                onChange={(e) => setBankDetail({ ...bankDetail, accountName: e.target.value })}
              />
            </Col>
            <Col>เลขบัญชี</Col>
            <Col sm={12} md={6} lg={4}>
              <input
                name="accountNo"
                className="form-control my-2"
                style={{ color: Colors.DARK_GREY }}
                placeholder="กรุณากรอกเลขบัญชีธนาคาร"
                minLength={BANK_LENGTH[bankDetail.bankName]?.accountMinLength}
                maxLength={BANK_LENGTH[bankDetail.bankName]?.accountMaxLength}
                value={bankDetail.accountNo}
                onChange={(e) => setBankDetail({ ...bankDetail, accountNo: e.target.value.replace(/[^0-9]/g, '') })}
              />
            </Col>
            <Col sm={12} md={12} lg={4}>
              <Button
                variant={bankList.length >= 3 ? 'primary light' : 'primary'}
                className="w-100 my-2"
                onClick={onSubmit}
                disabled={bankList.length >= 3}
              >
                เพิ่ม
              </Button>
            </Col>
          </BodyContainer>
        </Form.Group>
      </Card.Body>
    </Card>
  )
}
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

const ButtonCotainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`

const TitleText = styled.span`
  font-size: 20px;
  font-weight: 600;
`
const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  gap: 8px;
  width: 100%;
`

export default BookBankCollection
